import { all, put, call, takeEvery } from 'redux-saga/effects';
import { request } from '../../xhr';
import { fetchArtAuthor, fetchArtAuthorSuccess } from './actions';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        const users = require('@wix/da-sample-data').users;
        const randomUser = users[Math.round(Math.random() * (users.length - 1))];
        return {
            user: randomUser
        };
    }
}
function* fetchAuthor(action) {
    const { username  } = action.payload;
    const response = yield call(request, {
        method: 'get',
        url: '/user/info',
        params: {
            username
        }
    }, fakeResponse);
    if (response && response.user) {
        yield put(fetchArtAuthorSuccess({
            user: response.user
        }));
    }
}
export default function* saga() {
    yield all([
        takeEvery(fetchArtAuthor, fetchAuthor)
    ]);
}
